/**
 * Componente: UnlinkErrorView
 * 
 * Descrição: Exibe mensagem de erro quando ocorre falha no processo de desvinculação
 * de perfil. Oferece opções para tentar novamente ou voltar ao painel principal.
 * 
 * Este componente é parte da máquina de estados do fluxo de vinculação de usuários
 * e representa o estado de erro na desvinculação.
 */
import H1 from "../../../../../components/UI/Titles/H1/h1";
import RoundedButton from "../../../../../components/Buttons/RoundedButton";
import StateView from '../shared/StateView';
import LinkMessage from '../shared/LinkMessage';
import StateIcon from '../shared/StateIcon';
import classes from '../../RescueCode.module.scss';
import UnlinkedError from "../../../../../assets/images/Vector.svg";
/**
 * @param {Object} props - Propriedades do componente
 * @param {Function} props.updateState - Função para atualizar o estado da máquina de estados
 * @param {Function} props.redirectToDashboard - Função para redirecionar o usuário ao painel
 */
const UnlinkErrorView = ({ updateState, redirectToDashboard }) => {
  return (
    // Container principal com estilo específico para este estado
    <StateView className={classes.unlinkErrorContainer}>
      {/* Título da tela de erro */}
      <H1 className={classes.unlinkErrorTitle}>Ops! Algo deu errado</H1>

      {/* Mensagem explicativa do erro */}
      <LinkMessage className={classes.unlinkErrorMessage}>
        <p>Não foi possível desvincular seu perfil. Por favor, tente novamente mais tarde.</p>
      </LinkMessage>

      {/* Ícone de erro - utiliza o componente reutilizável StateIcon */}
      <StateIcon 
        imageSrc={UnlinkedError}
        altText="Erro na desvinculação"
        iconContainerClass={classes.unlinkErrorIconContainer}
        iconClass={classes.unlinkErrorIcon}
      />

      {/* Grupo de botões para ações do usuário */}
      <div className={classes.buttonGroup}>
        {/* Botão para tentar novamente - retorna para a tela de desvinculação */}
        <RoundedButton
          className={classes.returnButton}
          text="TENTAR NOVAMENTE"
          onClick={() => updateState({ current: "UNLINK_PROFILE" })}
        />
        {/* Botão para voltar ao painel principal */}
        <RoundedButton
          className={classes.returnButton}
          text="VOLTAR AO PAINEL"
          onClick={redirectToDashboard}
        />
      </div>
    </StateView>
  );
};

export default UnlinkErrorView;